import { Input } from 'synergy/models';
const { UPDATE_OR_CREATE } = Input.types;

export function setInput(data) {
  return {
    type: UPDATE_OR_CREATE,
    payload: data
  };
}
